/* Jolly Keeps: sticky header. Once the header + announcement bar scroll out of view,
   the header comes back as a compact fixed bar. A min-height on the section keeps the
   page from jumping. */
(function () {
  var state = null;

  function setup() {
    var hdr = document.querySelector('[data-jk-header]');
    if (!hdr) return;
    if (state && state.hdr === hdr) return;
    if (state) state.destroy();

    var wrap = hdr.parentElement;
    var group = document.getElementById('header-group') || wrap;
    var stuck = false;
    var ticking = false;

    function threshold() {
      return group.getBoundingClientRect().bottom + window.scrollY;
    }
    function stick() {
      wrap.style.minHeight = hdr.offsetHeight + 'px';
      hdr.classList.add('is-stuck');
      stuck = true;
      document.body.style.setProperty('--header-height', hdr.offsetHeight + 'px');
    }
    function unstick() {
      hdr.classList.remove('is-stuck');
      wrap.style.minHeight = '';
      stuck = false;
    }
    function check() {
      ticking = false;
      var y = window.scrollY;
      var t = threshold();
      if (!stuck && y > t) stick();
      else if (stuck && y <= t) unstick();
    }
    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(check);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    check();

    state = {
      hdr: hdr,
      destroy: function () {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        unstick();
      }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
  document.addEventListener('shopify:section:load', setup);
})();
